// extracted by mini-css-extract-plugin
module.exports = {"event-slider-root":"EventSlider_event-slider-root__uCUz6","event-wrapper":"EventSlider_event-wrapper__hHc0A","max-w":"EventSlider_max-w__3O3zV"};